import { BaseEvent } from "./baseEventType";

type Listener<T extends BaseEvent> = (event: T) => void;

interface EventConstructor<T extends BaseEvent> {
  new (...args: any[]): T;
  getEventType(): string;
}

export class TypedEventDispatcher {
  private listeners = new Map<string, Set<Listener<BaseEvent>>>();

  on<T extends BaseEvent>(k: EventConstructor<T>, callback: Listener<T>): void {
    const type = k.getEventType();

    if (!this.listeners.has(type)) {
      this.listeners.set(type, new Set());
    }
    this.listeners.get(type)!.add(callback as Listener<BaseEvent>);
  }

  emit<T extends BaseEvent>(event: T): void {
    const handlers = this.listeners.get(event.constructor.name);
    if (!handlers) return;
    for (const handler of handlers) {
      handler(event);
    }
  }

  off<T extends BaseEvent>(
    k: EventConstructor<T>,
    callback: Listener<T>
  ): void {
    const handlers = this.listeners.get(k.getEventType());
    if (handlers) {
      handlers.delete(callback as Listener<BaseEvent>);
    }
  }
}

export const eventDispacher = new TypedEventDispatcher();
